import axios from 'axios';
import { iJobPosts } from '../interfaces/job-posts';
import { iOpportunities } from '../interfaces/opportunities';
import { IProfessions } from '../interfaces/professions';


export default class API {

    professions: IProfessions[] = [];

    // private static ProfessionsPath = 'https://api2.worcket.com/public/professions';
    private static BasePath = 'https://gateway.worcket.com/public/company/opportunitiesbyname';

    static Paths = {
        Home: `${this.BasePath}/manpowergroup%20interno`,
        Professions: 'https://api2.worcket.com/public/professions',
        Manpower: `${this.BasePath}/manpower%20uruguay`,
        ManpowerBusiness: `${this.BasePath}/manpower%20bp`,
        Experis: `${this.BasePath}/experis`,
    }

    static getHome = () => {
        return new Promise<iJobPosts[]>((resolve, reject) => {
            axios.get(this.Paths.Home)
                .then(res => resolve(res.data || []))
                .catch(err => reject(err));
        })
    }




    static getProfessions = () => {
        return new Promise<IProfessions[]>((resolve, reject) => {
            axios.get(this.Paths.Professions)
                .then(res => resolve(res.data ? res.data.reverse() : []))
                .catch(err => reject(err));
        })
    }

    static getManpowerBusiness = () => {

        return new Promise<iOpportunities[]>((resolve, reject) => {

            axios.get(this.Paths.ManpowerBusiness).then(res => {
                return resolve(res.data || []);
            })
        })
    }

    static getManpower = () => {

        return new Promise<iOpportunities[]>((resolve, reject) => {

            axios.get(this.Paths.Manpower).then(res => {
                return resolve(res.data || []);
            })
        })
    }

    static getExperis = () => {
        return new Promise<iOpportunities[]>((resolve, reject) => {
            axios.get(this.Paths.Experis)
                .then(res => resolve(res.data || []))
                .catch(err => reject(err));
        })
    }

    static getBlog = () => {
        return new Promise((resolve, reject) => {
            axios.post(`https://api.hubapi.com/content/api/v2/blog-posts?hapikey=${process.env.REACT_APP_HUBSPOT_API_KEY}`)
                .then((res) => resolve(res))
                .catch(err => reject(err));
        })
    }

}